<template>
  <div>
    <ul class="newsUl wow animate__slideInUp">
      <li
        :key="idx"
        v-for="(item, idx) in newsList"
      >
        <a v-if="down" :href="item.Url" target="_blank">
          <span class="titBox">{{ item.Title }}</span>
          <span>
            {{ moment(item.PubDate).format("YYYY-MM-DD") }}
          </span>
          <span class="newMore">{{ actionTxt || "查看" }}</span>
        </a>

        <router-link v-else :to="`/newsContent?id=${item.Id}`">
          <span class="titBox">{{ item.Title }}</span>
          <span>
            {{ moment(item.PubDate).format("YYYY-MM-DD") }}
          </span>
          <span class="newMore">{{ lang=="en"?'Learn More':'了解更多' }}</span>
        </router-link>
      </li>
      <!-- <li class="animate__animated animate__slideInUp animate__delay-1s">
        <a href="">
          <span>青海省政协副主席张晓容一行莅临 西宁公司指导调研</span>
          <span>2022-02-20</span>
          <span class="newMore">{{actionTxt||'查看'}}</span>
        </a>
      </li>
      <li class="animate__animated animate__slideInUp animate__delay-2s">
        <a href="">
          <span>青海省政协副主席张晓容一行莅临 西宁公司指导调研</span>
          <span>2022-02-20</span>
          <span class="newMore">{{actionTxt||'查看'}}</span>
        </a>
      </li> -->
    </ul>
    <!-- <div class="pageBox">
      <Pagenation />
    </div> -->
  </div>
</template>

<script>
import Pagenation from "./Pagenation";

export default {
  data() {
    return {
      moment: this.$moment,
    };
  },
  props: ["actionTxt", "newsList", "down","lang"],
  components: {
    Pagenation,
  },
};
</script>

<style lang="scss">
.newsUl {
  border-top: 1px solid #ddd;
  // min-height: 200px;
  li {
    padding: 20px;
    border-bottom: 1px solid #ddd;
    &:hover {
      background-color: #f9f9f9;
      .newMore {
        color: #d71820;
      }
    }
    a {
      display: grid;
      grid-template-columns: 60% 30% 10%;
      justify-items: start;
      .titBox{text-align: left; padding-right:10px}
      .newMore {
        justify-self: end;
        white-space: nowrap
      }
    }
  }
}
.pageBox {
  padding: 40px 0;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #d71820 !important;
}
</style>